export enum PDFGenerationJobParsingMode {
  TABULAR = 'TABULAR',
  DEFAULT = 'DEFAULT',
  CITABLE = 'CITABLE',
}

export enum JSONGenerationJobParsingMode {
  XLSX_JSON_MINIFIER = 'XLSX_JSON_MINIFIER'
}